import { CROSSCUTTING_DONE_LIST_FAILED, CROSSCUTTING_DONE_LIST_REQUEST, CROSSCUTTING_DONE_LIST_SUCCESS } from "app/redux/actions/Factory/Crosscutting/crosscutDoneListing/constants";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const crossCutDoneListingReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case CROSSCUTTING_DONE_LIST_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case CROSSCUTTING_DONE_LIST_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case CROSSCUTTING_DONE_LIST_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};